import { useEffect, useState } from "react"
import withModal from "../../utils/hoc/withModal"
import { processPayout } from "../../services/api/wallet";
import { toast } from "react-toastify";
import { AppDispatch } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { fetchWalletData } from "../../redux-stores/slices/walletSlice";

interface PayoutProps {
    bankAccountNumber: string,
    amount: number,
    onClose: () => void,
    onConfirmation?: (isProcessing: boolean) => void,
}

const Payout: React.FC<PayoutProps> = ({ onClose, onConfirmation, bankAccountNumber, amount }) => {

    const [isProcessing, setProcessing] = useState<boolean>(false);
    const [status, setStatus] = useState<any>(null);
    const dispatch:AppDispatch = useDispatch();

    const [payoutResponseMessage, setPayoutResponseMessage] = useState('');

    const withdraw = async () => {
        if(!bankAccountNumber){
            return toast.error("Please add your bank details first to withdraw.")
        }
        if(amount < 1){
            return toast.error("Amount should be greater than zero to withdraw.")
        }
        if (status && status !== 'failed') return;
        setProcessing(true);
        try {
            const res = await processPayout(amount);
            if(res){
                if(res.payout){
                    setStatus(res.payout.status);
                }
                setPayoutResponseMessage(`Payout of ₹${amount} has been initiated and should be credited to your account in a few minutes.`);
            }
        } catch (error: any) {
            if(error.response?.data?.payout){
                setStatus(error.response.data.payout.status);
                setPayoutResponseMessage(error.response.data.error_message);
            }else{
                setStatus('failed');
                setPayoutResponseMessage("There was some issue in processing your payout, Please try again later.")
            }
        } finally {
            setProcessing(false);
        }
    }

    useEffect(() => {
        if (onConfirmation) {
            onConfirmation(isProcessing)
        }
    }, [isProcessing, onConfirmation])

    return (
        <div>
            <div className="menu-title p-3 mb-0">
                <h4 className="font-800">Withdraw</h4>
                <button className="close-menu" onClick={onClose}>
                    <i className="fa fa-times-circle"></i>
                </button>
            </div>
            <div className="content mt-0 pb-4">
                <div className="divider mb-3"></div>
                <div>
                    {
                        !isProcessing && !status &&
                        <span>
                            We are processing your withdrawal request immediately. The amount will be transferred to your bank account number ending in {bankAccountNumber.slice(-4)}.
                            Click Continue to proceed.
                        </span>
                    }
                    {
                        isProcessing &&
                        <div className="d-flex justify-content-center flex-column align-items-center">
                            <div className="spinner-border color-yellow-dark" role="status">
                            </div>
                            <span>
                                Processing payout of ₹{amount}
                            </span>
                            <span>
                                Do not press “Back” or close the window
                            </span>
                        </div>
                    }
                    {
                        !isProcessing && status !== null &&
                        <div className="d-flex justify-content-center flex-column align-items-center">
                            {
                                status === 'failed' &&
                                <span><i className="fa-regular fa-circle-xmark font-30 text-danger"></i></span>
                            }
                            {
                                status !== 'failed' &&
                                <span><i className="fa-regular fa-circle-check font-30 color-green-dark"></i></span>
                            }
                            <span className="text-center">
                                {payoutResponseMessage}
                            </span>
                        </div>

                    }
                </div>
                <div className="divider my-3"></div>
                <div className="d-flex justify-content-center gap-2 mb-2">
                    <button disabled={isProcessing} className="btn btn-sm w-100 btn-secondary rounded-sm" onClick={onClose}>Close</button>
                    {
                        (!status || status === 'failed') &&
                        <button disabled={isProcessing || (status && status !== 'failed')} className="btn btn-sm w-100 btn-primary rounded-sm" onClick={withdraw}>{status !== 'failed' ? 'Continue' : 'Retry'}</button>
                    }
                </div>
            </div>
        </div>
    )
}

export default withModal(Payout)